<form class="sdp-saml-wizard-form" novalidate>
	<div class="sdp-clear"></div>
	<div *ngIf="isDataLoaded">
		<div>
			<h5>{{ "sdp.label.option" | translate }} 1</h5>
			<div *ngFor="let option of idpOption; let i = index" class="sdp-saml-download-spacer" [ngSwitch]="option.type">
				<div *ngSwitchCase="'text'">
					<div class="sdp-saml-wizard-download-text-label">
						{{ option.displayName }}
					</div>
					<div class="sdp-saml-wizard-download-text-value sdp-ellipsis" matTooltip="{{ option.value }}" [matTooltipPosition]="'above'">
						{{ option.value }}
						<sdp-icon ngxClipboard [cbContent]="option.value" [icon]="copyIcon"></sdp-icon>
					</div>
					<div class="sdp-clear"></div>
				</div>
				<div *ngSwitchCase="'download'">
					<div class="sdp-saml-wizard-download-download-label">
						{{ option.displayName }}
					</div>
					<div class="sdp-saml-wizard-download-download-value sdp-ellipsis">
						<div class="sdp-saml-wizard-download-expiry">{{ "sdp.label.expires" | translate }} {{ getDate(option.expiry) }}</div>
						<div>
							<button class="sdp-saml-wizard-download-button" type="button" color="accent" (click)="download(option)" mat-raised-button>
								<sdp-icon [icon]="downloadIcon"></sdp-icon>
								{{ "sdp.label.download" | translate }}
							</button>
						</div>
					</div>
					<div class="sdp-clear"></div>
				</div>
			</div>
		</div>
		<div class="sdp-saml-download-seperator">
			<span>{{ "sdp.label.or" | translate }}</span>
			<div class="sdp-saml-download-seperator-line"></div>
		</div>
		<div>
			<h5>{{ "sdp.label.option" | translate }} 2</h5>
			<div class="sdp-saml-wizard-download-download-label sdp-saml-download-spacer">
				{{ "saml.wizard.download.metadata" | translate }}
			</div>
			<div class="sdp-saml-wizard-download-download-value sdp-ellipsis">
				<div>
					<button class="sdp-saml-wizard-download-button" type="button" color="accent" (click)="download(metadata)" mat-raised-button>
						<sdp-icon [icon]="downloadIcon"></sdp-icon>
						{{ "sdp.label.download" | translate }}
					</button>
				</div>
			</div>
			<div class="sdp-clear"></div>
		</div>
	</div>
</form>